export default {
  columns: {
    version: 'Wersja',
    signed_at: 'Podpisano',
    internal_note: 'Notatka wewnętrzna',
    signature_provider: 'Dostawca podpisu',
    file: 'Dokument',
    actions: 'Akcje',
  },
  labels: {
    version: 'v{{version}}',
    no_history: 'Brak historii podpisów',
    providers: {
      selfhosted: 'Własny hosting',
      yousign: 'Yousign',
    },
  },
  buttons: {
    preview: 'Podgląd',
    download: 'Pobierz',
  },
};
